<template>
  <v-card class="mt-0" id="userList" flat>
    <v-toolbar fixed flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Role Users</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" @click="close()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

       <v-list color="#ffffff00" style="max-height: 530px" class="overflow-y-auto">
        <v-list-item
        :class="{ active: index == currentIndex }"
        v-for="user in users"
        :key="user.SecurityUserID"
        @click="setActiveUser(user, index)"
        >
        <v-list-item-content>
            <v-list-item-title>{{ user.FullName }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.Email }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
            <v-chip color="error" small outlined v-if="user.UserIsDisabled == 1">disabled</v-chip>
            <v-chip color="success" small outlined v-else>active</v-chip>
        </v-list-item-action>
        </v-list-item>
      </v-list>
    <v-card-text>

    </v-card-text>
  </v-card>
</template>

<script>
import roleManagementService from '../services/roleManagement.service';
import UserService from '../services/user.service';

export default {
  name: 'role users',

  data () {
    return {
      message: '',
      search: '',
      currentUser: null,
      currentIndex: -1,
      // users: [],

    //   roles: [],
    //   role: {
    //     SecurityRoleID: null,
    //     Role: '',
    //     RoleCode: '',
    //     Description: '',
    //     IsDisabled: '',
    //   },
      // user: {
      //   SecurityUserID: '',
      //   UserID: '',
      //   FullName: '',
      //   Email: '',
      //   UserIsDisabled: '',
      // },
      submitted: false,
    }
  },

  props: ['users'],

  methods: {
    refreshList () {
      this.retrieveRoles ()
    },

    setActiveRole (role, index) {
      this.currentRole = role
      this.currentIndex = index
    },

    close() {
     this.$root.$emit("closeRoleUsers")
    },

    disableRole (status) {
      var data = {
        IsDisabled: status
      }

      roleManagementService.updateRoles(this.currentRole.SecurityRoleID, data)
        .then(() => {
          this.currentRole.IsDisabled = status
          
          this.refreshList()
        })
        .catch(e => {
          console.log(e)
        })
    },
  },

  mounted () {
    UserService.getManagerBoard().then(
      response => {
        this.content = response.data;
        this.retrieveUsers ();
        this.retrieveRoles ();
        this.message = '';
        this.getUser(this.$route.params.id)
      },
      error => {
        this.content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
#userList {
    background-color: white ;
}

.v-btn {
  outline: none
}

.title {
    color:#2A353D ;
}

.headline {
  color:white;
};
</style>
